import React, {useEffect, useState} from 'react'
import s from '../styles/StudentProfile.module.scss'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import {push, validateName, validateUserName} from 'Utils/validation'
import avi from 'Static/default-avi.png'
import {AiOutlineEdit} from 'react-icons/ai'
import {TextAreaInput, TextInput} from 'Input/Input';
import {Root} from 'Root';
import EditProfilePic from './Components/EditProfilePic';
import {setSessionCookie} from "../../../Utils/sessions";

function chainError(err) {
    return Promise.reject(err)
}

function removeEmptyValues(request) {
    var copy = {}
    Object.assign(copy, request)
    Object.keys(copy).forEach(key => {
        if (copy[key].length === 0) {
            delete copy[key]
        }
    })
    return copy
}

export const EditApplicantProfile = ({profile, session, refreshSession, beginEditing}) => {
    const [editing, setEditing] = useState(beginEditing);
    const [show, setShow] = useState(beginEditing);
    const [request, setRequest] = useState({});
    const [responseError, setResponseError] = useState(null);

    const handleClose = () => {
        setShow(false);
        setEditing(false);
        const currentHref = window.location.href
        if (currentHref.endsWith('/edit')) {
            window.location.href = currentHref.replace("/edit", "")
        }

    }

    const handleShow = () => setShow(true);

    const handleEdit = () => {
        setEditing(true);
        setRequest({});
    }

    function finishEditing() {
        setResponseError(null);

        if (request === undefined || Object.values(request).filter(value => value.length > 0).length === 0) {
            handleClose()
            return;
        }

        // Handle username update first
        if (request.userName && request.userName !== session.userName) {
            Root.userApi.updateUsername(request.userName, session.jwt)
                .then((newJWT) => {
                    Root.userApi.getSignedInUserInformation(newJWT.data).then(res => {
                        let user = res.data?.user;
                        user.jwt = res.data?.jwt;
                        setSessionCookie(user);
                        refreshSession(user)
                    }).then(() => handleUpdateUser())
                        .catch((err) => {
                            setResponseError(err.response?.data)
                            setEditing(false)
                        })
                })
                .catch((err) => {
                    setResponseError(err.response?.data)
                    setEditing(false)
                })
        } else {
            handleUpdateUser();
        }
    }

    function handleUpdateUser() {
        // Only continue if we don't have an issue updating the username
        if (Object.keys(request).length > 0) {
            let filtered = removeEmptyValues(request)
            Root.userApi.updateUser({basicInformation: filtered}, session.jwt).then(res => {
                setRequest({})
                refreshSession()
                setEditing(false)
            }).catch((err) => {
                setResponseError('Error saving changes')
            })
        }
    }


    return <div className={s.editProfile}>
        <Button className=' btnOutline wide' onClick={handleShow}>Edit Profile</Button>
        <Modal show={show} onHide={handleClose} animation={false} fullscreen={"lg-down"}>
            <Modal.Header closeButton>
                <Modal.Title>Edit Profile</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='d-flex justify-content-center'>
                    <img src={profile.photo || avi}
                         style={{height: '90px', width: '90px', objectFit: 'cover', borderRadius: '50%'}} alt={''}/>
                </div>
                <EditProfilePic session={session} refreshSession={refreshSession}/>
                <EditNameForm profile={profile} editing={editing} setRequest={setRequest} request={request}/>
                <EditUsernameForm profile={profile} editing={editing} session={session} setRequest={setRequest}
                                  request={request}/>
                <EditBioForm profile={profile} editing={editing} setRequest={setRequest} request={request}/>
                <p className='mb-1 mt-2'><strong>NXSTEP Profile</strong></p>
                <Button href='/onboarding?prev=ep' className='btnLink ps-0'>Update NXSTEP Profile</Button>
            </Modal.Body>
            <Modal.Footer>
                {<p className='form-error'>{responseError}</p>}
                {editing && <Button className='btnFill' onClick={finishEditing}>
                    {Object.values(request).filter(value => value.length > 0).length === 0 ? 'Cancel' : 'Save Changes'}
                </Button>}
                {!editing &&
                    <Button className='btnOutline' onClick={handleEdit}>
                        <AiOutlineEdit/> Edit Profile
                    </Button>
                }
            </Modal.Footer>
        </Modal>
    </div>
}

const EditNameForm = ({profile, setRequest, editing, request}) => {
    const [formErrors, setFormErrors] = useState({});

    function handleChange(event) {
        const {name, value} = event.target;
        setRequest(prevState => ({...prevState, [name]: value}));
    }

    useEffect(() => {
        setFormErrors({})
        const errors = {};
        if (request.firstName && !validateName(request.firstName)) {
            push(errors, 'firstName', 'Valid first name is required ')
        }
        if (request.lastName && !validateName(request.lastName)) {
            push(errors, 'lastName', 'Valid last name is required ')
        }
        if (Object.keys(errors).length > 0) {
            setFormErrors(errors)
        }
    }, [request])

    return <div className='p-2'>
        <div className='d-flex align-items-center justify-content-between'>
            {!editing && <p className='mb-1'>
                <strong>Name</strong>
                <span className='text-muted d-block'>{profile.firstName} {profile.lastName}</span>
            </p>}
            {editing && <>
                <TextInput className='mr-2' errors={formErrors} label={'First Name'} name={'firstName'}
                           value={request.firstName} onChange={handleChange} type={'firstName'}
                           placeholder={profile.firstName}/>
                <TextInput className='ml-2' errors={formErrors} label={'Last Name'} name={'lastName'}
                           value={request.lastName} onChange={handleChange} type={'lastName'}
                           placeholder={profile.lastName}/>
            </>
            }
        </div>
    </div>;

}

const EditUsernameForm = ({setRequest, request, editing, session}) => {
    const [formErrors, setFormErrors] = useState({});

    function handleChange(event) {
        const {name, value} = event.target;
        setRequest(prevState => ({...prevState, [name]: value}));
    }

    useEffect(() => {
        setFormErrors({})
        const errors = {};
        if (request.userName && !validateUserName(request.userName)) {
            push(errors, 'userName', 'Username must at least be 5 characters. Numbers, letters, underscores and dashes are allowed')
        }
        if (Object.keys(errors).length > 0) {
            setFormErrors(errors)
        }
    }, [request])

    return <div className={`${s.greyBg} p-2`}>
        <div>
            {!editing && <p className='mb-1'>
                <strong>Username</strong>
                <span className='text-muted d-block'>@{session.userName}</span>
            </p>}

            {editing && <TextInput errors={formErrors} label={'Username'} name={'userName'}
                                   value={request.userName} onChange={handleChange} type={'text'}
                                   placeholder={`${session.userName}`}/>}
        </div>
    </div>;
}

const EditBioForm = ({profile, setRequest, request, editing}) => {
    const [formErrors, setFormErrors] = useState({});

    function handleChange(event) {
        const {name, value} = event.target;
        setRequest(prevState => ({...prevState, [name]: value}));
    }

    useEffect(() => {
        setFormErrors({})
        const errors = {};
        if (request.firstName && !validateUserName(request.firstName)) {
            push(errors, 'userName', 'Username must at least be 5 characters. Numbers, letters, underscores and dashes are allowed')
        }
        if (Object.keys(errors).length > 0) {
            setFormErrors(errors)
        }
    }, [request])

    return <div className={`${s.greyBg} p-2`}>
        <div className={`d-flex align-items-center justify-content-between`}>
            {!editing && <p className='mb-1'>
                <strong>About Me</strong>
                <span className='text-muted d-block'>{profile.bio}</span>
            </p>}
            {editing && <TextAreaInput errors={formErrors} label={'About Me'} name={'bio'}
                                       value={request.bio} onChange={handleChange} type={'text'}
                                       placeholder={`${profile.bio}`}/>}
        </div>
    </div>;
}